/**
 * AI Chat Feature Types
 *
 * Local types specific to the AI Chat feature UI components.
 */

export { type AIChatMessage, type AIChatCard, type AIChatCardType } from '../../types/ai-chat.types';

/**
 * Props for message components
 */
export interface MessageProps {
  message: import('../../types/ai-chat.types').AIChatMessage;
  isLast?: boolean;
  onRetry?: () => void;
}

/**
 * Props for card components
 */
export interface CardProps<T = Record<string, unknown>> {
  data: T;
  onAction?: (action: string, payload?: Record<string, unknown>) => void;
}

/**
 * Animation variants for messages
 */
export const messageAnimationVariants = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
};

/**
 * Chat panel dimensions
 */
export const CHAT_PANEL_DIMENSIONS = {
  minWidth: 380,
  maxWidth: 600,
  defaultWidth: 440,
  headerHeight: 64,
  inputHeight: 80,
  fullscreenMaxWidth: 900,
} as const;

